console.log('DELIVERY LEAD JS LOADED');

/* =====================================================
   YAKKI: 確認モーダル制御（変更なし）
   - window.__REQUIRE_CONFIRMATION__ が true の時だけ動作
===================================================== */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.__REQUIRE_CONFIRMATION__) return;

  const modal = document.getElementById('confirm-modal');
  const checkbox = document.getElementById('confirm-checkbox');
  const okBtn = document.getElementById('confirm-ok');

  if (!modal || !checkbox || !okBtn) return;

  let bypass = false;

  checkbox.addEventListener('change', function () {
    okBtn.disabled = !checkbox.checked;
  });

  // add-to-cart をキャプチャ段階でブロック（AJAXカートの既存処理を壊さない）
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('[type="submit"][name="add"]');
      if (!btn) return;

      if (bypass) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      modal.hidden = false;
    },
    true
  );

  // OK後にだけ本来のクリック（=テーマのAJAXカート処理）へ戻す
  okBtn.addEventListener('click', function () {
    bypass = true;
    modal.hidden = true;
    checkbox.checked = false;
    okBtn.disabled = true;

    const btn = document.querySelector('[type="submit"][name="add"]');
    if (btn) btn.click();

    setTimeout(() => (bypass = false), 1000);
  });
});

/* =====================================================
   CART: 配送リード日表示（cart専用・固定文言表示・即時実行）
===================================================== */
(function initCartDeliveryLead() {
  // 表示先（既存DOMに合わせる）
  const summaryContainer = document.querySelector('.delivery-lead-summary');
  if (!summaryContainer) return;

  // 固定文言（HTMLは必要最小限）
  const html = `
    <p class="delivery-lead-text">
      14時までのご注文で即日発送（休業日除く）<br>
      <span class="delivery-lead-note">※一部商品は当日〜5日以内の発送となります</span>
    </p>
  `;

  summaryContainer.innerHTML = html;
})();

/* =====================================================
   REQUIRED SELECT（既存仕様の補強）
   - .required-select の data-required="true" を必須扱い
   - data-label を properties[] のキーとして hidden に格納
===================================================== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', function (e) {
      const selects = form.querySelectorAll('.required-select');
      if (!selects.length) return;

      for (const select of selects) {
        const isRequired =
          String(select.dataset.required || '').toLowerCase() === 'true' ||
          select.hasAttribute('required');

        const label =
          (select.dataset.label || select.dataset.property || '').trim() ||
          '必須項目';

        if (isRequired && !select.value) {
          alert(label + 'を選択してください');
          e.preventDefault();
          return;
        }

        // properties に入れる（hidden）
        let hidden = form.querySelector(
          `input[name="properties[${CSS.escape(label)}]"]`
        );

        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = `properties[${label}]`;
          form.appendChild(hidden);
        }

        hidden.value = select.value;
      }
    });
  });
});

/* =====================================================
   REFSEL（紹介店舗選択）
   修正版：検索欄を常時表示 / shokai_20off 対応
   -----------------------------------------------------
   動作仕様:
   1. 紹介コード検索欄は商品ページ上に常時表示する。
   2. 紹介コードを入力すると候補を表示する。
   3. 候補を選択すると、選択済み表示を出す。
   4. 選択済みコードをカート属性 referral_store に保存する。
   5. 未選択でカート追加クリック
      → カート追加は止めて、紹介コード検索欄へフォーカスする。
   6. 選択済みでカート追加クリック
      → テーマ本来のAjaxカート処理に任せる。
   7. 右側カートポップアップのカート遷移ボタンをクリック
      → 紹介コードが000以外なら
        /discount/shokai_20off?redirect=/cart
        へ遷移する。
   8. 000は割引なし
      → 通常通りカート画面へ移動する。
===================================================== */

document.addEventListener('DOMContentLoaded', function () {
  if (!window.__REFSEL_REQUIRED__) return;
  if (!window.__REFSEL_LOGGED_IN__) return;

  function normalizeShopCode(code) {
    const s = String(code || '').trim();

    if (!s) return '';

    if (/^\d+$/.test(s) && s.length <= 3) {
      return s.padStart(3, '0');
    }

    return s.toUpperCase();
  }

  const DISCOUNT_CODE = String(window.__REFSEL_DISCOUNT_CODE__ || 'shokai_20off').trim();
  const SKIP_CODE = normalizeShopCode(window.__REFSEL_DISCOUNT_SKIP_CODE__ || '000');

  const SELECTED_CODE_KEY = '__refsel_selected_code__';
  const SELECTED_NAME_KEY = '__refsel_selected_name__';

  let currentRef = '';
  let currentName = '';
  let isProcessingCartRedirect = false;

  const root = document.querySelector('[data-refsel-root]');
  const modal = document.querySelector('[data-refsel-modal]');

  if (!root) return;

  const selectedText = root.querySelector('[data-refsel-selected]');
  const shopsWrap = root.querySelector('[data-refsel-shops]');
  const codeInput = root.querySelector('[data-refsel-code]');
  const listBody = root.querySelector('[data-refsel-listbody]');
  const resultBox = root.querySelector('[data-refsel-result]');
  const listWrap = root.querySelector('[data-refsel-list]');

  const closeBtns = modal ? modal.querySelectorAll('[data-refsel-close]') : [];

  if (!shopsWrap || !codeInput || !listBody) return;

  function isValidInputCode(value) {
    const s = String(value || '').trim();
    if (!s) return false;
    return /^[A-Za-z0-9]{1,20}$/.test(s);
  }

  function setStoredSelection(code, name) {
    const c = normalizeShopCode(code);
    const n = String(name || '').trim();

    currentRef = c;
    currentName = n;

    root.setAttribute('data-refsel-current', c);
    root.setAttribute('data-refsel-current-name', n);

    if (selectedText) {
      selectedText.setAttribute('data-refsel-selected-code', c);
      selectedText.setAttribute('data-refsel-selected-name', n);
    }

    try {
      sessionStorage.setItem(SELECTED_CODE_KEY, c);
      sessionStorage.setItem(SELECTED_NAME_KEY, n);
    } catch (e) {}
  }

  function getStoredSelectionCode() {
    const fromCurrent = normalizeShopCode(currentRef);
    if (fromCurrent) return fromCurrent;

    const fromRoot = normalizeShopCode(root.getAttribute('data-refsel-current') || '');
    if (fromRoot) return fromRoot;

    const fromSelectedText = selectedText
      ? normalizeShopCode(selectedText.getAttribute('data-refsel-selected-code') || '')
      : '';

    if (fromSelectedText) return fromSelectedText;

    try {
      const fromSession = normalizeShopCode(sessionStorage.getItem(SELECTED_CODE_KEY) || '');
      if (fromSession) return fromSession;
    } catch (e) {}

    return '';
  }

  function getStoredSelectionName() {
    if (currentName) return currentName;

    const fromRoot = String(root.getAttribute('data-refsel-current-name') || '').trim();
    if (fromRoot) return fromRoot;

    const fromSelectedText = selectedText
      ? String(selectedText.getAttribute('data-refsel-selected-name') || '').trim()
      : '';

    if (fromSelectedText) return fromSelectedText;

    try {
      return String(sessionStorage.getItem(SELECTED_NAME_KEY) || '').trim();
    } catch (e) {
      return '';
    }
  }

  function clearStoredSelection() {
    currentRef = '';
    currentName = '';

    root.removeAttribute('data-refsel-current');
    root.removeAttribute('data-refsel-current-name');

    if (selectedText) {
      selectedText.removeAttribute('data-refsel-selected-code');
      selectedText.removeAttribute('data-refsel-selected-name');
      selectedText.style.display = 'none';
      selectedText.textContent = '';
    }

    try {
      sessionStorage.removeItem(SELECTED_CODE_KEY);
      sessionStorage.removeItem(SELECTED_NAME_KEY);
    } catch (e) {}
  }

  function showResultMessage(message) {
    if (!resultBox) return;

    resultBox.style.display = 'block';
    resultBox.textContent = message;
  }

  function hideResultMessage() {
    if (!resultBox) return;

    resultBox.style.display = 'none';
    resultBox.textContent = '';
  }

  function clearList() {
    listBody.innerHTML = '';

    if (listWrap) {
      listWrap.style.display = 'none';
    }
  }

  function showList() {
    if (listWrap) {
      listWrap.style.display = 'block';
    }
  }

  function focusSearch(message) {
    if (message) {
      showResultMessage(message);
    }

    try {
      codeInput.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } catch (e) {}

    setTimeout(function () {
      try {
        codeInput.focus();
      } catch (e) {}
    }, 0);
  }

  function closeModal() {
    if (modal) {
      modal.style.display = 'none';
    }
  }

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  // ===== 店舗データ読み込み =====

  let shops = [];

  shops = Array.from(root.querySelectorAll('[data-refsel-shop]'))
    .map(function (el) {
      return {
        code: normalizeShopCode(el.getAttribute('data-code') || ''),
        name: String(el.getAttribute('data-name') || '').trim(),
        is_active: String(el.getAttribute('data-is-active') || 'true').trim(),
        sort_order: Number(el.getAttribute('data-sort-order') || 9999)
      };
    })
    .filter(function (s) {
      return s.code && s.name && s.is_active !== 'false';
    })
    .sort(function (a, b) {
      const orderDiff = Number(a.sort_order || 9999) - Number(b.sort_order || 9999);
      if (orderDiff !== 0) return orderDiff;
      return String(a.code).localeCompare(String(b.code));
    });

  shops.unshift({
    code: SKIP_CODE,
    name: '選択しない',
    is_active: 'true',
    sort_order: -9999
  });

  function findShopByInput(value) {
    const raw = String(value || '').trim();

    if (!isValidInputCode(raw)) return null;
    if (/^\d+$/.test(raw) && raw.length < 3) return null;

    const q = normalizeShopCode(raw);

    return shops.find(function (s) {
      return s.code === q;
    }) || null;
  }

  function findShopByCode(code) {
    const c = normalizeShopCode(code);

    if (!c) return null;

    return shops.find(function (s) {
      return s.code === c;
    }) || null;
  }

  function renderSelectedLabel(shop) {
    if (!selectedText) return;

    if (!shop || !shop.code) {
      selectedText.style.display = 'none';
      selectedText.textContent = '';
      return;
    }

    selectedText.textContent = '選択済み：' + shop.code + ' ' + shop.name;
    selectedText.style.display = 'block';
    selectedText.setAttribute('data-refsel-selected-code', shop.code);
    selectedText.setAttribute('data-refsel-selected-name', shop.name);
  }

  function renderList(items) {
    listBody.innerHTML = '';

    if (!items.length) {
      clearList();
      return;
    }

    showList();

    items.forEach(function (shop) {
      const btn = document.createElement('button');

      btn.type = 'button';
      btn.textContent = shop.code + '　' + shop.name;
      btn.style.display = 'block';
      btn.style.width = '100%';
      btn.style.textAlign = 'left';
      btn.style.padding = '10px';
      btn.style.marginTop = '6px';
      btn.style.border = '1px solid rgba(0,0,0,.08)';
      btn.style.background = '#fff';
      btn.style.borderRadius = '8px';
      btn.style.cursor = 'pointer';

      btn.addEventListener('click', function () {
        selectShop(shop);
      });

      listBody.appendChild(btn);
    });
  }

  async function updateCartReferralAttribute(shop) {
    const code = normalizeShopCode(shop && shop.code ? shop.code : '');

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          referral_store: code
        }
      })
    });

    if (!response.ok) {
      throw new Error('cart attribute update failed');
    }

    return await response.json();
  }

  async function selectShop(shop) {
    if (!shop || !shop.code) return;

    const selectedShop = {
      code: normalizeShopCode(shop.code),
      name: String(shop.name || '').trim()
    };

    try {
      await updateCartReferralAttribute(selectedShop);
    } catch (e) {
      showResultMessage('保存に失敗しました。通信状況をご確認のうえ、もう一度お試しください。');
      return;
    }

    setStoredSelection(selectedShop.code, selectedShop.name);
    renderSelectedLabel(selectedShop);
    hideResultMessage();
    clearList();

    codeInput.value = '';
  }

  // ===== 紹介コード入力 =====

  clearList();

  codeInput.addEventListener('input', function () {
    const raw = String(codeInput.value || '').trim();

    hideResultMessage();

    if (!raw) {
      clearList();
      return;
    }

    if (!isValidInputCode(raw)) {
      clearList();
      showResultMessage('紹介コードは半角英数字で入力してください。');
      return;
    }

    if (/^\d+$/.test(raw) && raw.length < 3) {
      clearList();
      return;
    }

    const found = findShopByInput(raw);

    if (found) {
      renderList([found]);
    } else {
      clearList();
      showResultMessage('該当する紹介コードが見つかりません。正しいコードを入力してください。');
    }
  });

  codeInput.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;

    e.preventDefault();

    const raw = String(codeInput.value || '').trim();

    if (!isValidInputCode(raw)) {
      clearList();
      showResultMessage('紹介コードは半角英数字で入力してください。');
      return;
    }

    const found = findShopByInput(raw);

    if (found) {
      selectShop(found);
    } else {
      clearList();
      showResultMessage('該当する紹介コードが見つかりません。正しいコードを入力してください。');
    }
  });

  // ===== 初期表示の復元 =====
  // 同一セッション内で選択済みの場合のみ、表示を復元します。
  // 復元時もカート属性 referral_store を再保存します。

  (function restoreSelectionFromSession() {
    let code = '';
    let name = '';

    try {
      code = normalizeShopCode(sessionStorage.getItem(SELECTED_CODE_KEY) || '');
      name = String(sessionStorage.getItem(SELECTED_NAME_KEY) || '').trim();
    } catch (e) {}

    if (!code) {
      clearStoredSelection();
      return;
    }

    const shop = findShopByCode(code) || {
      code: code,
      name: name || code
    };

    setStoredSelection(shop.code, shop.name);
    renderSelectedLabel(shop);

    updateCartReferralAttribute(shop).catch(function () {
      // 復元時の再保存に失敗しても画面操作は止めない
    });
  })();

  // ===== カート追加時：未選択チェックのみ =====

  function findAddButtonFromEvent(e) {
    if (!e || !e.target || !e.target.closest) return null;

    return (
      e.target.closest('form[action*="/cart/add"] [type="submit"]') ||
      e.target.closest('form[action*="/cart/add"] button[name="add"]') ||
      e.target.closest('[type="submit"][name="add"]') ||
      e.target.closest('button[name="add"]')
    );
  }

  function getProductForm(btn) {
    if (!btn) return null;

    return (
      btn.closest('form[action*="/cart/add"]') ||
      btn.closest('form[data-type="add-to-cart-form"]') ||
      btn.closest('form[data-js-product-form]') ||
      btn.closest('form') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-js-product-form]')
    );
  }

  function isProductAddForm(form) {
    if (!form) return false;

    const action = String(form.getAttribute('action') || '');
    const type = String(form.getAttribute('data-type') || '');

    return (
      action.indexOf('/cart/add') !== -1 ||
      type === 'add-to-cart-form' ||
      form.hasAttribute('data-js-product-form')
    );
  }

  function requireSelectionIfNeeded(e, form) {
    if (!isProductAddForm(form)) return false;

    const selectedCode = getStoredSelectionCode();

    if (selectedCode) {
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    focusSearch('紹介コードを選択してください。');

    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      const btn = findAddButtonFromEvent(e);

      if (!btn) return;

      const form = getProductForm(btn);
      if (!form) return;

      requireSelectionIfNeeded(e, form);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;

      if (!form) return;

      requireSelectionIfNeeded(e, form);
    },
    true
  );

  // ===== カート画面へ移動する時に割引適用 =====
  // カート追加時にはページ遷移しない。
  // 右側カートポップアップ内の「カートへ進む／購入へ進む」ボタンを押した時だけ
  // /discount/shokai_20off?redirect=/cart を踏ませる。

  function findPopupCartToCartTrigger(e) {
    if (!e || !e.target || !e.target.closest) return null;

    return (
      e.target.closest('.popup-cart__buttons a.input-checkbox-disable-body') ||
      e.target.closest('.popup-cart__buttons a[href*="/cart"]') ||
      e.target.closest('.popup-cart a.input-checkbox-disable-body') ||
      e.target.closest('.popup-cart a.btn[href*="/cart"]') ||
      e.target.closest('a[href*="/cart"]')
    );
  }

  function buildDiscountCartUrl() {
    return (
      '/discount/' +
      encodeURIComponent(DISCOUNT_CODE) +
      '?redirect=' +
      encodeURIComponent('/cart')
    );
  }

  async function goCartWithDiscount(selectedCode) {
    if (isProcessingCartRedirect) return;

    isProcessingCartRedirect = true;

    const selectedShop = findShopByCode(selectedCode) || {
      code: selectedCode,
      name: getStoredSelectionName() || selectedCode
    };

    try {
      await updateCartReferralAttribute(selectedShop);
    } catch (e) {
      isProcessingCartRedirect = false;
      alert('紹介コードの保存に失敗しました。通信状況をご確認のうえ、もう一度お試しください。');
      return;
    }

    window.location.href = buildDiscountCartUrl();
  }

  document.addEventListener(
    'click',
    function (e) {
      const trigger = findPopupCartToCartTrigger(e);

      if (!trigger) return;

      const href = String(trigger.getAttribute('href') || '');

      if (href.indexOf('/cart') === -1) return;
      if (href.indexOf('/cart/add') !== -1) return;

      const selectedCode = getStoredSelectionCode();

      // 未選択の場合は、通常のカート遷移を止めて選択を促す
      if (!selectedCode) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        focusSearch('紹介コードを選択してください。');
        return;
      }

      // 000は割引なしのため、通常通りカート画面へ移動
      if (normalizeShopCode(selectedCode) === SKIP_CODE) return;

      // 割引コードが未設定の場合も通常通りカート画面へ移動
      if (!DISCOUNT_CODE) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      goCartWithDiscount(selectedCode);
    },
    true
  );
});